import { PropTypes } from 'prop-types';
import React from 'react';

import ProjectCard from '../../../components/project-card';
import RecruitLinkCard from '../../../components/recruit-link-card';
import withLayout from '../../../../core/components/with-layout';
import { config } from '../../../../config';

import {
  BackButton,
  Container,
  Instruction,
} from './styles';

const RecruitParticipantLink = (props) => {
  const {
    history: {
      location: {
        state: {
          project: {
            recruitParticipantToken,
            testType,
          },
        },
      },
      push,
    },
  } = props;

  const { token } = recruitParticipantToken;
  const url = `${config.REACT_APP_TESTER_PLATFORM_URI}/recruit-participants?token=${token}`;

  return (
    <Container>
      <BackButton
        onClick={() => push({ pathname: '/', state: null })}
      >
        &lt; Return to Projects
      </BackButton>

      <RecruitLinkCard
        testType={testType}
        title="Thanks for submitting a study with PlaybookUX!"
        url={url}
      />

      <ProjectCard title="Sample Email Text">
        <Instruction>
          Hi [Name],
        </Instruction>

        <Instruction>
          We&apos;re working to improve our [website/product] experience and would like to get your feedback.
        </Instruction>

        <Instruction>
          The session will last 15 minutes. In return, we would like to offer [describe compensation].
        </Instruction>

        <Instruction>
          Please complete the study on a desktop or laptop, not a mobile phone.
          Take the study in a quiet place - such as an office or your home - not a coffee shop.
        </Instruction>

        <Instruction>
          The link below will launch the study.
          {testType !== 'card_sort' && (
            <>
              &nbsp;It will record your voice and screen while you answer questions.
              Please speak your thoughts aloud. We want to hear your honest opinions. Your feedback is invaluable.
            </>
          )}
        </Instruction>

        <Instruction>
          [Insert custom recruiting link]
        </Instruction>

        <Instruction>
          Thanks,
        </Instruction>

        <Instruction>
          [Name]
        </Instruction>
      </ProjectCard>
    </Container>
  );
};

RecruitParticipantLink.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func,
    location: {
      state: {
        project: {
          recruitParticipantToken: {
            token: PropTypes.string,
          },
        },
      },
    },
  }).isRequired,
};

export default withLayout()(RecruitParticipantLink);
